import React from 'react';
import SEO from '@/components/common/SEO';
import LandingShell from '@/components/landing/LandingShell';
import {
  EulaDocumentContent,
  legalCompanyAddress,
  legalCompanyName,
  legalContactEmail,
  legalLastUpdated,
} from '@/components/legal/LegalDocuments';

export const lastUpdated: string = legalLastUpdated;
export const companyName: string = legalCompanyName;
export const contactEmail: string = legalContactEmail;
export const companyAddress: string = legalCompanyAddress;

const Eula = () => {
  return (
    <LandingShell>
      <SEO
        title="EULA"
        description="Read the mapleos End User License Agreement covering service use, restrictions, privacy, and legal terms."
        url="/eula"
      />
      <div className="container mx-auto max-w-4xl px-4 py-8 md:py-12">
        <h1 className="mb-6 text-3xl font-bold">End User License Agreement</h1>
        <div className="prose prose-sm dark:prose-invert max-w-none">
          <EulaDocumentContent />
        </div>
      </div>
    </LandingShell>
  );
};

export default Eula;
